import { Link } from "react-router-dom";
import { useCustomer } from "../customer/CustomerContext";
import { FAVORITE_CATALOG } from "../customer/catalog";

export function FavoritesPage() {
  const { favorites, toggleFavorite, isFavorite, customer } = useCustomer();

  return (
    <article className="page account-page">
      <p className="eyebrow">Customer account</p>
      <h1>Favorites</h1>
      <p className="page-summary">
        Save services you care about
        {customer ? " — synced to your account." : ". Log in to sync them across devices."}
      </p>

      <ul className="favorites-grid">
        {FAVORITE_CATALOG.map((item) => {
          const on = isFavorite(item.id);
          return (
            <li key={item.id} className="favorites-item">
              <div>
                <Link to={item.href} className="favorites-title">
                  {item.label}
                </Link>
                <p>{item.note}</p>
              </div>
              <button
                type="button"
                className={`header-tool-btn favorites-toggle${on ? " favorites-toggle--on" : ""}`}
                aria-pressed={on}
                onClick={() => toggleFavorite(item.id)}
              >
                {on ? "Saved" : "Save"}
              </button>
            </li>
          );
        })}
      </ul>

      {favorites.length === 0 ? (
        <p className="account-muted">You have not saved any favorites yet.</p>
      ) : null}

      <p className="account-switch">
        {customer ? (
          <Link to="/account">← Back to account</Link>
        ) : (
          <>
            <Link to="/account/login">Log in</Link> or{" "}
            <Link to="/account/register">register</Link> to manage purchases.
          </>
        )}
      </p>
    </article>
  );
}
